import { IFormValidationError } from '../eo-form/eo-form.config';

export const defaultFormValidationError: IFormValidationError = {
  required: 'Αυτό το πεδίο είναι υποχρεωτικό.',
  minlength: 'Πρέπει να ξεπεράσετε το ελάχιστο αριθμό χαρακτήρων.',
  maxlength: 'Έχετε ξεπεράσει το μέγιστο αριθμό χαρακτήρων.',
  pattern: 'Μη έγκυρη εισαγωγή. Επιτρέπεται μόνο συγκεκριμένο πρότυπο.',
  email: 'Μη έγκυρη μορφή ηλεκτρονικού ταχυδρομείου.',
  min: 'Η τιμή που έχετε πληκτρολογήσει είναι μικρότερη από το επιτρεπτό όριο.',
  max: 'Η τιμή που έχετε πληκτρολογήσει είναι μεγαλύτερη από το επιτρεπτό όριο.',
  nullValidator: '', // No error message for nullValidator
};
